import { gql } from '@apollo/client';
import { TRANSACTION_FRAGMENT } from './TRANSACTION_FRAGMENT';

export const CANCEL_TRANSACTION_MUTATION = gql`
  mutation CancelTransaction($id: Int!, $source: TransactionSource!) {
    in {
      cancelTransaction(id: $id, source: $source) {
        success
        message {
          code
          message
        }
        content {
          ...TransactionFragment
        }
      }
    }
  }
  ${TRANSACTION_FRAGMENT}
`;
